import React from 'react'
import TaxDelete from "./TaxDelete";
import TaxEdit from "./TaxEdit";

const TaxActions = ({record, updater}) => {

    return(
        <React.Fragment>
            <TaxEdit tax={record} updater={updater} />
            <TaxDelete tax={record} updater={updater} />
        </React.Fragment>
    )
}
export default TaxActions